<template>
  <div class="eltree">
    <div class="eltree-treehead pl-32 fontbig">
      <div class="eltree-treehead-left">资源名称</div>
      <div class="eltree-treehead-right">
        <p class="detail">服务详情</p>
      </div>
    </div>
    <el-tree
      ref="tree"
      :data="treeList"
      node-key="id"
      :props="props"
      icon-class="el-icon-arrow-right"
      :load="loadNode"
      lazy
    >
      <!-- :expand-on-click-node="false" -->
      <div class="eltree-treenode" slot-scope="{ node, data }">
        <span
          v-if="data.type == 1"
          :class="
            `icon tsit icon_shipinziyuanguanli icon-style ${
              data.status == 'ON' ? 'fontblue' : ''
            }`
          "
        ></span>
        <span v-else :class="`icon tsit icon_shujuji icon-style `"></span>
        <div class="eltree-treenode-left">
          {{ data.name }}
          <div class="treeNum" v-if="data.type == 0">{{ data.num }}</div>
        </div>
        <div class="eltree-treenode-right">
          <div class="btn" v-if="data.dataList && data.dataList.length > 0">
            <Button
              class="mr-8"
              shape="circle"
              size="small"
              v-for="(item, index) in data.dataList"
              :key="index"
            >
              <img :src="item.companyLogo" alt="" class="imgClass" />
              <Tooltip
                transfer
                placement="top"
                v-if="item.serviceName.length > 5"
                :content="item.serviceName"
              >
                <span class="ml-4 fontthreedark">{{
                  item.serviceName.substring(0, 5) + "..."
                }}</span>
              </Tooltip>
              <span v-else class="ml-4 fontthreedark">{{
                item.serviceName
              }}</span>
            </Button>
            <Dropdown placement="bottom-start">
              <!-- 更多服务 -->
              <Button
                class="mr-8"
                shape="circle"
                size="small"
                v-if="data.moreList.length"
              >
                <i class="icon tsit icon_gengduofuwu fontblue"></i>
                <span style="top: 1px" class="ml-4 fontthreedark"
                  >+{{ data.moreList.length }}服务</span
                >
              </Button>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, idx) in data.moreList" :key="idx">{{
                  item.serviceName
                }}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <p class="btn" v-else>-</p>
        </div>
      </div>
    </el-tree>
  </div>
</template>
<script>
import { getServePubilshResourceList } from "@/api/serviceUse";
import { getMyAppVideoTree, getMyAppVideoTreeFirst } from "@/api/app";
export default {
  name: "",
  components: {},
  props: {
    appFlag: String,
    userId: Number,
  },
  data() {
    return {
      treeList: [],
      props: {
        label: "name",
        isLeaf: "leaf",
      },
      id: null,
      showDetail: false,
      videoForm: {},
      nodeForm: {
        nodeHead: null,
        resloveHead: null,
      },
      firstNode: {},
    };
  },
  created() {
    this.id = this.$route.query.id;
  },
  methods: {
    loadNode(node, resolve) {
      console.log(node, "node--", "appFlag", this.appFlag);
      //获取服务使用者==发布服务==资源列表
      if (this.appFlag && this.appFlag == "1") {
        if (node.level == 0) {
          getServePubilshResourceList(this.id).then((res) => {
            console.log(res, "获取根节点");
            let json = res.data.data;
            if (!json && json.length == 0) {
              this.$emit("isData", false);
              return resolve([]);
            }
            if (json && json.length != 0) {
              //父组件回显总的视频资源数量
              // this.$emit("update:totalNum", json[0].childNum);
              this.$emit("isData", true);
              return resolve(res.data.data);
            }
          });
        }
        if (node.key) {
          getServePubilshResourceList(this.id, { resourceId: node.key }).then(
            (res) => {
              let json = res.data.data;
              if (!json) return resolve([]);
              if (json.length) {
                json.forEach((item) => {
                  item.pid = node.key;
                  if (item.type == 1) {
                    item.leaf = true;
                    if (item.services && item.services.length > 3) {
                      item.dataList = item.services.filter(
                        (x, index) => index < 2
                      );
                      item.moreList = item.services.filter(
                        (x, index) => index >= 2
                      );
                    } else {
                      item.dataList = item.services;
                      item.moreList = [];
                    }
                  }
                });
              }
              return resolve(json);
            }
          );
        }
      }
      //获取应用管理==查看详情==资源列表
      if (this.appFlag && this.appFlag == "0") {
        if (node.level == 0) {
          getMyAppVideoTreeFirst(this.id, { userId: this.userId }).then(
            (res) => {
              console.log(res, "获取根节点");
              let json = res.data.data;
              console.log("json", json);
              this.firstNode = json;
              if (!json) {
                this.$emit("isData", false);
                return resolve([]);
              }
              if (json) {
                //父组件回显总的视频资源数量
                // this.$emit("update:totalNum", json[0].childNum);
                this.$emit("isData", true);
                this.$emit("update:groupId", json.groupId);
                return resolve([json]);
              }
            }
          );
        }
        if (node.key) {
          console.log("是否执行了");
          getMyAppVideoTree(
            this.firstNode.groupId,
            node.data.parentId,
            this.id
          ).then((res) => {
            let json = res.data.data;
            if (!json) return resolve([]);
            if (json.length) {
              json.forEach((item) => {
                // item.pid = node.key;
                if (item.type == 1) {
                  item.leaf = true;
                  if (item.services && item.services.length > 3) {
                    item.dataList = item.services.filter(
                      (x, index) => index < 2
                    );
                    item.moreList = item.services.filter(
                      (x, index) => index >= 2
                    );
                  } else {
                    item.dataList = item.services;
                    item.moreList = [];
                  }
                }
              });
            }
            return resolve(json);
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.eltree {
  width: 100%;
  height: 100%;
  background: #fff;
  &-treehead {
    height: 55px;
    background: #fafafa;
    display: flex;
    align-items: center;
    &-left {
      width: 50%;
    }
    &-right {
      width: 50%;
      display: flex;
    }
  }
  .eltree-treenode {
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
    .icon-style {
      // color: #85878b;
      margin: -1px 5px 0;
      height: 100%;
    }
    &-left {
      width: 50%;
      display: flex;
      align-items: center;
    }
    &-right {
      width: 50%;
      display: flex;
      > .btn {
        width: calc(100% - 108px);
        overflow: hidden;
        // white-space: nowrap;
        margin-right: 16px;
        .ivu-btn-small {
          height: 25px;
        }
        img {
          width: 20px;
          height: 20px;
          position: relative;
          top: 2px;
          border-radius: 50%;
        }
        span {
          position: relative;
          top: -2px;
        }
      }
      .action {
        width: 92px;
      }
    }
  }
  .el-tree-node__content {
    height: 55px;
    border-bottom: 1px solid #f0f0f0;
  }
  .el-tree-node__content:hover {
    background-color: rgba(60, 138, 255, 0.05);
  }
  //选中背景色
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: rgba(60, 138, 255, 0.05) !important;
  }
}
</style>
